import { Store } from '@/stores';
import { useMapStoreStateToClientState } from '@/hooks/useMapStoreStateToClientState';

const useStateOfGrouping = (store: Store, isRoundTrip: boolean) => {
  return useMapStoreStateToClientState(store, (store) => {
    return {
      itineraryGroupMap: isRoundTrip
        ? store.appStore.stepByStepSearchPage.currentStepStore.itineraryGroupMap
        : store.appStore.completeSearchPage.itineraryGroupMap,
    };
  });
};

export default useStateOfGrouping;
